var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "19px",
    viewBox: "0 0 24 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webbsite-1.0",
    transform: "translate(-107.000000, -977.000000)",
    fill: "#6C6C6C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.14204,981.9416 C128.15192,982.14376 128.15572,982.34668 128.15572,982.55188 C128.15572,988.78464 123.4118,995.97044 114.73716,995.97044 C112.07412,995.97044 109.59424,995.18992 107.50728,993.85232 C107.87664,993.89564 108.25132,993.91768 108.63208,993.91768 C110.84216,993.91768 112.87592,993.16376 114.4894,991.89912 C112.426,991.86036 110.68484,990.49616 110.08444,988.62276 C110.37172,988.679 110.66736,988.70712 110.97136,988.70712 C111.40152,988.70712 111.818,988.65088 112.21396,988.5422 C110.05556,988.109 108.42992,986.2014 108.42992,983.91836 C108.42992,983.89784 108.42992,983.87808 108.43068,983.85756 C109.06604,984.21096 109.79336,984.423 110.56704,984.44808 C109.30088,983.60068 108.46868,982.15896 108.46868,980.52192 C108.46868,979.6578 108.70124,978.84688 109.10708,978.15072 C111.43344,981.00376 114.90892,982.88172 118.829,983.0778 C118.74844,982.73352 118.70664,982.37252 118.70664,982.00316 C118.70664,979.3994 120.81792,977.28736 123.4232,977.28736 C124.7798,977.28736 126.00492,977.8604 126.86524,978.7762 C127.93988,978.56568 128.94916,978.172 129.8604,977.63164 C129.507,978.73364 128.75992,979.6578 127.7856,980.24072 C128.74092,980.12672 129.64988,979.87288 130.495,979.4982 C129.8642,980.44592 129.06392,981.2766 128.14204,981.9416 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.537b7efb3a92ac0031aeb3a36dfec5d0.svg";
export { ForwardRef as ReactComponent };